function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asMultiStyleConfig } from '../../utils/theme';
import { mode } from '../../theme-tools';
var baseStyle = {
  table: {
    fontVariantNumeric: 'lining-nums tabular-nums',
    borderCollapse: 'collapse',
    width: 'full'
  },
  th: {
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: '16px',
    letterSpacing: 'wider',
    textAlign: 'start'
  },
  td: {
    fontSize: '16px',
    textAlign: 'start'
  },
  caption: {
    mt: 4,
    fontFamily: 'heading',
    textAlign: 'center',
    fontWeight: 'medium'
  }
};
var numericStyles = {
  '&[data-is-numeric=true]': {
    textAlign: 'end'
  }
};
var variantSimple = props => {
  var {
    colorScheme: c
  } = props;
  return {
    th: _objectSpread({
      color: mode('gray.600', 'gray.400')(props),
      borderBottom: '1px',
      borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
    }, numericStyles),
    td: _objectSpread({
      borderBottom: '1px',
      borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
    }, numericStyles),
    caption: {
      color: mode('gray.600', 'gray.100')(props)
    },
    tfoot: {
      tr: {
        '&:last-of-type': {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
};
var variantStripe = props => {
  var {
    colorScheme: c
  } = props;
  return {
    th: _objectSpread({
      color: mode('gray.600', 'gray.400')(props),
      borderBottom: '1px',
      borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
    }, numericStyles),
    td: _objectSpread({
      borderBottom: '1px',
      borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
    }, numericStyles),
    caption: {
      color: mode('gray.600', 'gray.100')(props)
    },
    tbody: {
      tr: {
        '&:nth-of-type(odd)': {
          'th, td': {
            borderBottomWidth: '1px',
            borderColor: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
          },
          td: {
            background: mode("".concat(c, ".100"), "".concat(c, ".700"))(props)
          }
        }
      }
    },
    tfoot: {
      tr: {
        '&:last-of-type': {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
};
var variants = {
  simple: variantSimple,
  striped: variantStripe,
  unstyled: {}
};
var sizes = {
  sm: {
    th: {
      px: '4',
      py: '1',
      lineHeight: '4',
      fontSize: 'sm'
    },
    td: {
      px: '4',
      py: '2',
      fontSize: 'sm',
      lineHeight: '4'
    },
    caption: {
      px: '4',
      py: '2',
      fontSize: 'xs'
    }
  },
  md: {
    th: {
      px: '6',
      py: '3',
      lineHeight: '4',
      fontSize: 'md'
    },
    td: {
      px: '6',
      py: '4',
      lineHeight: '5'
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: 'md'
    }
  },
  lg: {
    th: {
      px: '8',
      py: '4',
      lineHeight: '5',
      fontSize: 'lg'
    },
    td: {
      px: '8',
      py: '5',
      lineHeight: '6'
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: 'lg'
    }
  }
};
var defaultProps = {
  variant: 'simple',
  size: 'md',
  colorScheme: 'gray'
};
export default asMultiStyleConfig({
  parts: ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'tfoot', 'caption'],
  baseStyle,
  variants,
  sizes,
  defaultProps
});